import { Button } from '@planuze/ui';
import type { SubmissionAction } from '../../hooks/use-pack-submissions.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';
import { actionVariant } from './submission-action-config.js';

interface Props {
  readonly selectedLabel: string;
  readonly clearLabel: string;
  readonly actions: readonly SubmissionAction[];
  readonly actionLabels: Readonly<Record<SubmissionAction, string>>;
  readonly busy: boolean;
  readonly onApply: (action: SubmissionAction) => void;
  readonly onClear: () => void;
}

/** Ações comuns à seleção homogênea; a page congela IDs, ação e justificativa no diálogo. */
export function PackSubmissionsBulkBar({
  selectedLabel,
  clearLabel,
  actions,
  actionLabels,
  busy,
  onApply,
  onClear,
}: Props) {
  return (
    <BulkSelectionBar
      selectedLabel={selectedLabel}
      clearLabel={clearLabel}
      busy={busy}
      onClear={onClear}
    >
      {actions.map((action) => (
        <Button
          key={action}
          size="sm"
          variant={actionVariant(action)}
          disabled={busy}
          onClick={() => onApply(action)}
        >
          {actionLabels[action]}
        </Button>
      ))}
    </BulkSelectionBar>
  );
}
